import { Chip, Spacer, Text } from '@vinted/web-ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const OptionsSection = _ref => {
  let {
    onClick,
    options,
    ratingOptionsTitle,
    selectedValues
  } = _ref;

  const renderChip = _ref2 => {
    let {
      body,
      id,
      hasMessageInput
    } = _ref2;
    const isActive = selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.includes(id);

    const handleClick = () => {
      onClick(id, hasMessageInput);
    };

    return /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(Chip, {
        testId: "feedback-statement-".concat(id),
        text: body,
        textType: Text.Type.Subtitle,
        activated: isActive,
        type: "button",
        onClick: handleClick,
        aria: {
          'aria-pressed': isActive
        }
      }), /*#__PURE__*/_jsx(Spacer, {
        orientation: Spacer.Orientation.Vertical
      }), /*#__PURE__*/_jsx(Spacer, {})]
    }, id);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: "u-ui-padding-horizontal-large",
    children: [/*#__PURE__*/_jsx(Text, {
      text: ratingOptionsTitle,
      type: Text.Type.Title
    }), /*#__PURE__*/_jsx(Spacer, {
      size: Spacer.Size.Large
    }), /*#__PURE__*/_jsx("div", {
      className: "u-flexbox u-flex-wrap u-align-items-center",
      children: options.map(renderChip)
    })]
  });
};

export { OptionsSection };